import {ShiftEffect} from './shift.effect';

export const ShiftEffects = [ShiftEffect];



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/effects/index.ts